import { combineReducers } from 'redux';
import { combineForms } from 'react-redux-form';
import { routerReducer } from 'react-router-redux';
import { initialStates } from '../initialStates';
import storeReducer from './storeReducer';
import userReducer from './userReducer';
import {
  resetStateReducer,
  verifyReducer,
  questionsReducer,
  answersReducer,
  newPasswordReducer,
  verifyResetLinkReducer
} from './resetReducer';
import viewReducer from './viewReducer';
import staffReducer from './staffReducer';
import aboutYouReducer from './aboutYouReducer';
import storeDetailReducer from './storeDetailReducer';
import registrationReducer from './registrationReducer';
import userGroupsReducer from './userGroupsReducer';
import navigationLinksReducer from './navigationLinksReducer';
import usersReducer from './usersReducer';
import notificationsReducer from './notificationsReducer';
import pagesReducer from './pagesReducer';
import customerNumberReducer from './customerNumberReducer';
import storeDelinkReducer from './storeDelinkReducer';
import logoutReducer from './logoutReducer';
import welcomeReducer from './welcomeReducer';
import { categoriesReducer, brandsReducer, productsReducer, groupSelectorReducer } from './productsReducer';
import dataExportsReducer from './dataExportsReducer';
import dataImportsReducer from './dataImportReducer';
import templateReducer from './templateReducer';
import ppcReducer from './ppcReducer';
import pointsReducer from './pointsReducer';
import pointsStatementReducer from './pointsStatementReducer';
import incentivesReducer from './incentivesReducer';
import voucherReducer from './voucherReducer';
import { newsCategoriesReducer, newsArticlesReducer } from './newsReducer';
import contentReducer from './contentReducer';
import secondaryContentReducer from './secondaryContentReducer';
import homeReducer from './homeReducer';
import repHomeReducer from './repHomeReducer';
import preLoginHomeReducer from './preLoginHomeReducer';
import aboutIgniteReducer from './aboutIgniteReducer';
import latestNewsReducer from './latestNewsReducer';
import howToEarnReducer from './howToEarnReducer';
import articleReducer from './articleReducer';
import messagesReducer from './messagesReducer';
import filesReducer from './filesReducer';
import privacyPolicyReducer from './privacyPolicyReducer';
import levelReducer from './levelReducer';
import homePageReducer from './homePagesReducer';
import groupReducer from './groupsReducer';
import submissionReducer from './submissionsReducer';
import reportsReducer from './reportsReducer';
import stockItReducer from './stockItReducer';
import priceItReducer from './priceItReducer';
import displayItReducer from './displayItReducer';
import postcodePlanReducer from './postcodePlanReducer';
import teamStoreDetailReducer from './teamStoreDetailReducer';
import productPageReducer from './productPageReducer';
import userProductsListReducer from './userProductsListReducer';
import appSettingsReducer from './appSettingsReducer';
import pushNotificationsReducer from './pushNotificationsReducer';
import accessTokenReducer from './accessTokenReducer';
import logReducer from './logReducer';
import pointsTypesReducer from './pointsTypesReducer';
import marketingConsentsReducer from './marketingConsentsReducer';
import featuresReducer from './featuresReducer';
import navigationBackgroundReducer from './navigationImageReducer';
import brandsUserReducer from './brandsUserReducer';
import adminLinksReducer from './adminLinksReducer';
import storePerformanceObjectivesReducer from './storePerformanceObjectivesReducer';
import porDealsReducer from './porDealsReducer';
import porBannersReducer from './porBannersReducer';
import postcodePlanObjectivesReducer from './postcodePlanObjectivesReducer';
import inactivePorDealsReducer from './inactivePorDealsReducer';
import scansReducer from './scansReducer';
import adminEligibilitiesReducer from './adminEligibilitiesReducer';
import featureTogglesReducer from './featureTogglesReducer';

export default combineReducers({
  router: routerReducer,
  viewConfig: viewReducer,
  stores: storeReducer,
  delink: storeDelinkReducer,
  currentUser: userReducer,
  resetState: resetStateReducer,
  newPasswordState: newPasswordReducer,
  verifyResetLink: verifyResetLinkReducer,
  verifyPIN: verifyReducer,
  questions: combineReducers({
    questions: questionsReducer,
    answers: answersReducer
  }),
  welcome: welcomeReducer,
  staff: staffReducer,
  aboutYou: aboutYouReducer,
  store: storeDetailReducer,
  customer_numbers: customerNumberReducer,
  registration: registrationReducer,
  userGroups: userGroupsReducer,
  navigationLinks: navigationLinksReducer,
  users: usersReducer,
  logout: logoutReducer,
  notifications: notificationsReducer,
  pages: pagesReducer,
  data_exports: dataExportsReducer,
  data_imports: dataImportsReducer,
  categories: categoriesReducer,
  brands: brandsReducer,
  products: productsReducer,
  groupSelector: groupSelectorReducer,
  templates: templateReducer,
  ppc: ppcReducer,
  points: pointsReducer,
  points_statement: pointsStatementReducer,
  incentives: incentivesReducer,
  voucher: voucherReducer,
  home: homeReducer,
  repHome: repHomeReducer,
  preLoginHome: preLoginHomeReducer,
  aboutIgnite: aboutIgniteReducer,
  latestNews: latestNewsReducer,
  howToEarn: howToEarnReducer,
  article: articleReducer,
  news: combineReducers({
    categories: newsCategoriesReducer,
    articles: newsArticlesReducer,
  }),
  content: contentReducer,
  secondaryContent: secondaryContentReducer,
  messages: messagesReducer,
  files: filesReducer,
  groups: groupReducer,
  privacyPolicy: privacyPolicyReducer,
  level: levelReducer,
  homePage: homePageReducer,
  submissions: submissionReducer,
  reports: reportsReducer,
  stock_its: stockItReducer,
  price_its: priceItReducer,
  eligibilities: adminEligibilitiesReducer,
  display_its: displayItReducer,
  postcode_plans: postcodePlanReducer,
  teamStoreDetail: teamStoreDetailReducer,
  productPage: productPageReducer,
  userProductsList: userProductsListReducer,
  appSettings: appSettingsReducer,
  pushNotifications: pushNotificationsReducer,
  accessTokens: accessTokenReducer,
  notificationLog: logReducer,
  pointsTypes: pointsTypesReducer,
  marketingConsents: marketingConsentsReducer,
  deep: combineForms(initialStates, 'deep'),
  features: featuresReducer,
  navigationBackground: navigationBackgroundReducer,
  brandsUser: brandsUserReducer,
  adminLinks: adminLinksReducer,
  storePerformanceObjectives: storePerformanceObjectivesReducer,
  porDeals: porDealsReducer,
  porBanners: porBannersReducer,
  postcodePlanObjectives: postcodePlanObjectivesReducer,
  inactivePorDeals: inactivePorDealsReducer,
  scans: scansReducer,
  featureToggles: featureTogglesReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js